<template>
  <ChatBody :domain="domain" type-call="AUDIENCE" />
  <ChatDmFooter v-if="state.isVisibleDm" />
  <ChatFooter
    v-show="!state.isVisibleDm"
    type-call="AUDIENCE"
    :domain="domain"
    :list-button-visible="CHAT_FOOTER_PRESETS.AUDIENCE"
  />
</template>

<script setup lang="ts">
import { computed, inject, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

import ChatBody from '@/components/domains/chat/common/ChatBody.vue';
import ChatDmFooter from '@/components/domains/chat/common/ChatDmFooter.vue';
import ChatFooter from '@/components/domains/chat/common/ChatFooter.vue';
import { useUserStore } from '@/stores/user';
import { TypeDomain } from '@/types/common';
import { DEFAULT_CHAT_UI_STATE, CHAT_FOOTER_PRESETS } from '@/utils/constants/chat';
import { DOMAIN } from '@/utils/constants/common';
import { ij_chat_ui } from '@/utils/injectionKeys';

const { state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE); // provide: ChatLayout
const route = useRoute();
const userStore = useUserStore();

const domain = computed<TypeDomain>(() => {
  const metaDomain = route.meta.domain;
  return metaDomain && Object.values(DOMAIN).includes(metaDomain) ? metaDomain : 'CHAT';
});

onMounted(() => {
  const levelSize = userStore.isTablet ? 5 : 3;
  userStore.setTextMultiplier(levelSize);
});

onUnmounted(() => {
  userStore.setTextMultiplier(0);
});
</script>

<style lang="scss" scoped></style>
